// Two-pane conversation thread: live updates, optimistic send, list search
$(document).ready(function() {
  const page = document.getElementById('cv-thread-page');
  if (!page) return;

  const thread = document.getElementById('cv-messages');
  const conversationId = page.dataset.conversationId; // the conversation's slug
  const userId = page.dataset.userId;

  function scrollToBottom() {
    thread.scrollTop = thread.scrollHeight;
  }
  scrollToBottom();

  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

  // Live updates from other participants; own messages are appended
  // optimistically on send, so skip our own broadcasts.
  App.cable.subscriptions.create({ channel: 'ConversationChannel', conversation: conversationId }, {
    received(data) {
      if (String(data.sender_id) === String(userId)) return;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = data.message;
      while (wrapper.firstChild) {
        thread.appendChild(wrapper.firstChild);
      }
      scrollToBottom();
      markRead(data.message_id);
    }
  });

  // The thread is open, so a message that just arrived has been seen; move
  // the server-side read pointer so it is not counted or emailed as unread.
  function markRead(messageId) {
    if (!messageId) return;
    fetch('/conversations/' + conversationId + '/read', {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrfToken, 'X-Requested-With': 'XMLHttpRequest' },
      body: new URLSearchParams({ message_id: messageId })
    }).catch(function() {});
  }

  const form = document.getElementById('cv-composer');
  const input = document.getElementById('cv-input');
  const send = document.getElementById('cv-send');

  function updateSendState() {
    send.disabled = input.value.trim() === '';
  }
  input.addEventListener('input', updateSendState);
  updateSendState();

  // Enter sends; Shift+Enter inserts a newline
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submitMessage();
    }
  });

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    submitMessage();
  });

  function submitMessage() {
    const body = input.value.trim();
    if (!body) return;

    // Optimistic append
    const template = document.getElementById('cv-own-template');
    const node = template.content.firstElementChild.cloneNode(true);
    node.querySelector('.cv-bubble').textContent = body;
    thread.appendChild(node);
    scrollToBottom();

    input.value = '';
    updateSendState();
    input.focus();
    updateOwnRow(body);

    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams({ body: body })
    }).then(function(response) {
      if (!response.ok) throw new Error('send failed');
    }).catch(function() {
      node.classList.add('cv-msg--failed');
      node.title = 'Failed to send';
    });
  }

  // Keep the list row for this thread in step with a message we just sent;
  // incoming messages update it from notifications.js instead.
  function updateOwnRow(body) {
    const rows = document.querySelector('.cv-rows');
    const row = rows && rows.querySelector('.cv-row[data-conversation-id="' + conversationId + '"]');
    if (!row) return;

    const preview = row.querySelector('.cv-row-preview');
    const time = row.querySelector('.cv-row-time');
    if (preview) preview.textContent = 'You: ' + body;
    if (time) time.textContent = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).toLowerCase().replace(' ', '');
    rows.prepend(row);
  }

  // Client-side conversation list search by participant name
  const search = document.getElementById('cv-search');
  if (search) {
    search.addEventListener('input', function() {
      const query = search.value.trim().toLowerCase();
      document.querySelectorAll('.cv-row').forEach(function(row) {
        row.style.display = !query || row.dataset.name.includes(query) ? '' : 'none';
      });
    });
  }
});
